import { Box, Drawer, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
type StudioEmptyPanelProps = {
  title: string;
  message: string;
  drawerWidth: number;
  logoSrc: string;
};

// Right panel shown when the Inspector has nothing to edit. Deliberately no
// close button: unmounting it would hand its width to the preview (#4374).
export const StudioEmptyPanel = ({
  title,
  message,
  drawerWidth,
  logoSrc
}: StudioEmptyPanelProps) => {
  const {
    t
  } = useTranslation();
  return <Drawer data-cy="StudioEmptyPanel" variant="permanent" anchor="right" PaperProps={{
    sx: {
      overflow: "hidden",
      position: "relative",
      width: drawerWidth,
      boxSizing: "border-box",
      borderLeft: theme => `1px solid ${theme.palette.border}`,
      backgroundColor: theme => theme.palette.grey[50]
    }
  }} data-sentry-element="Drawer" data-sentry-component="StudioEmptyPanel" data-sentry-source-file="StudioEmptyPanel.tsx">
      <Box height="100%" display="flex" flexDirection="column" p={3} gap={2} data-sentry-element="Box" data-sentry-source-file="StudioEmptyPanel.tsx">
        {/* Height of the Inspector's title row with its small close button, so
            the body does not shift when the panels swap. */}
        <Stack direction="row" alignItems="center" minHeight={36} data-sentry-element="Stack" data-sentry-source-file="StudioEmptyPanel.tsx">
          <Typography data-cy="StudioEmptyPanelTitle" variant="subtitle1" fontWeight="600" data-sentry-element="Typography" data-sentry-source-file="StudioEmptyPanel.tsx">
            {title}
          </Typography>
        </Stack>
        <Typography data-cy="StudioEmptyPanelMessage" variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="StudioEmptyPanel.tsx">
          {message}
        </Typography>

        <Box mt="auto" display="flex" flexDirection="column" alignItems="center" gap={1} data-sentry-element="Box" data-sentry-source-file="StudioEmptyPanel.tsx">
          <Box component="img" src={logoSrc} alt="Content One" sx={{
          height: 24
        }} data-sentry-element="Box" data-sentry-source-file="StudioEmptyPanel.tsx" />
          <Typography variant="body3" color="text.secondary" textAlign="center" data-sentry-element="Typography" data-sentry-source-file="StudioEmptyPanel.tsx">
            {t("content.footerTagline")}
          </Typography>
        </Box>
      </Box>
    </Drawer>;
};